
/* injects from baggage-loader */

'use strict';

import ProductDocumentsComponent from './product.documents.component';

const ProductDocumentsPageModule = angular.module('product-documents-module', [
  'ui.router'
])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('product.documents', {
        data: {
          title: 'Documents'
        },
        url: '/documents',
        component: 'productDocuments',
        // Resolve promises into controller bindings, see component for bindings
        resolve: {
          documents: function (product, ProductDocument) {
            if (!product.get('documents')) {
              return [];
            }
            // TODO: query for product.get('parent').get('documents').query()
            return product.get('documents').query()
              .limit(1000).find();
          },
          parentDocuments: function (product, ProductDocument) {
            const parent = product.get('parent');
            if (!parent || !parent.get('documents')) {
              return [];
            }
            // TODO: query for product.get('parent').get('documents').query()
            return parent.get('documents').query()
              .limit(1000).find();
          },
        }
      });
  })
  .component('productDocuments', new ProductDocumentsComponent());

export default ProductDocumentsPageModule;



// WEBPACK FOOTER //
// ./src/app/pages/product/documents/product.documents.module.js